import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import NavBar from './NavBar/index';

const DashboardLayout = ({ children, routes }) => {
  const isNavOpen = true;

  return (
    <Box
      sx={{
        backgroundColor: 'background.dark',
        display: 'flex',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <NavBar onNavClose={() => {}} routes={routes} openMobile={isNavOpen} />
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          paddingTop: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flex: '1 1 auto',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
